export const telefoneWpp = "5531999085528";
export const urlWpp = `https://api.whatsapp.com/send?phone=${telefoneWpp}&text=`;
